import { useEffect } from 'react';
import isNil from 'ramda/src/isNil';

/* 
    TODO
    add type to ref
 */

const useOnEscapeBlur = (ref: any, disabled = false) => {
  const listener = (event: KeyboardEvent) => {
    if (!isNil(ref?.current) && event.key === 'Escape') {
      ref.current.blur();
    }
  };

  useEffect(() => {
    if (!disabled) {
      document.addEventListener('keydown', listener);

      return () => {
        document.removeEventListener('keydown', listener);
      };
    }
    return;
  }, [ref]);
};

export default useOnEscapeBlur;
